import { merge } from 'lodash';
import { Grid, useMediaQuery } from '@mui/material';

import { type FiltersType } from '../hooks/useFilters';
import useSettings from '../hooks/useSettings';
import FilterItemManager, { type MiddlewhereFilter } from './FilterItemManager';

interface FilterProps {
	/** The module name */
	module: string;
	/** An array of filters applied by default */
	defaultFilters: MiddlewhereFilter[];
	/** A list of current applied filters */
	currentFilters: FiltersType['currentFilters'];
	/** Function used to update a filter */
	handleFilterChange: FiltersType['handleFilterChange'];
}

export default function Filter(props: FilterProps) {
	const { settings } = useSettings(props.module);
	const isSmDown = useMediaQuery(theme => theme.breakpoints.down('sm'));

	const filtersTypes = settings?.filter_types.map(filterType => {
		const defaultFilter = props.defaultFilters.find(filter => filter.filt_field === filterType.filt_field);
		const currentValue = props.currentFilters.find(filter => filter.filt_field === filterType.filt_field);

		return merge(
			{
				filt_default_clause: defaultFilter?.filt_clause,
				filt_current_clause: currentValue?.filt_clause,
				filt_default_value: defaultFilter?.filt_value,
				filt_current_value: currentValue?.filt_value
			},
			filterType
		);
	});

	return (
		<Grid container columns={!isSmDown ? 2 : 1} spacing={1.5}>
			{filtersTypes?.map(
				filter =>
					filter.filt_visible && (
						<FilterItemManager
							key={filter.filt_id}
							filter={filter}
							handleFilterChange={props.handleFilterChange}
						/>
					)
			)}
		</Grid>
	);
}
